import { AfterViewInit, Component, forwardRef, Injector, Input } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormControlName,
  FormGroupDirective,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  NgForm,
  NgModel,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { NgIf } from '@angular/common';
import reduce from 'lodash/reduce';
import find from 'lodash/find';
import {getErrorMessage} from "../../../core/utils/functions";

@Component({
    selector: 'eco-input-autocomplete',
    templateUrl: './eco-input-autocomplete.component.html',
    styleUrl: './eco-input-autocomplete.component.scss',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EcoInputAutocompleteComponent),
            multi: true,
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EcoInputAutocompleteComponent),
            multi: true,
        },
    ],
    imports: [AutoCompleteModule, TranslateModule, ReactiveFormsModule, NgIf]
})
export class EcoInputAutocompleteComponent
  implements Validator, ControlValueAccessor, AfterViewInit
{
  @Input() label: string = 'EMPTY';
  @Input() placeholder: string = 'EMPTY';
  @Input() showLabel: boolean = true;
  @Input() options: any;
  @Input() isMultiSelect: boolean = true;
  @Input() display = 'comma';
  @Input() filter: boolean = false;
  @Input() field: string = 'name';
  @Input() optionDisabled: string = 'disabled';
  @Input() scrollHeight: string = '200px';
  @Input() showClear: boolean = true;
  @Input() readonly: boolean = false;
  @Input() tooltip?: any;
  @Input() border: boolean = false;
  @Input() virtualScroll: boolean = false;

  filteredOptions: any[] = [];
  control = new FormControl();
  ngControl?: NgControl;

  constructor(private injector: Injector) {
    this.control.valueChanges.subscribe(value => {
      if (this.onChange) {
        const val = value?.map((e: any) => {
          return e.code;
        });
        this.onChange(val);
      }
    });
  }

  ngAfterViewInit() {
    const ngControl: NgControl | null = this.injector.get(NgControl, null);
    if (ngControl) {
      setTimeout(() => {
        this.ngControl = ngControl;
        this.control = ngControl.control as FormControl;
      });
    }
  }

  get errors() {
    return (
      (((this.ngControl as NgModel | FormControlName)?.formDirective as NgForm | FormGroupDirective)
        ?.submitted ||
        this.ngControl?.touched ||
        this.ngControl?.dirty) &&
      this.ngControl?.errors &&
      !this.readonly
    );
  }

  completeMethod(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let option of this.options) {
      if (option.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(option);
      }
    }
    this.filteredOptions = filtered;
  }

  onChange = (_value: any) => {};

  onTouched = () => {};

  //Lấy ra message lỗi validate để hiển thị, nếu có nhiều lỗi -> hiển thị lỗi đầu tiên.
  getError() {
    return getErrorMessage(this.ngControl?.errors, this.label);
  }

  //Dùng để check trường hiện tại có phải required hay không.
  checkRequire() {
    return this.ngControl?.control?.hasValidator(Validators.required);
  }

  writeValue(value: any): void {
    let tmp = this.mapData(value);
    this.control.setValue(tmp);
  }

  mapData(valArray: string[]) {
    return reduce(
      valArray,
      (prev: string[], curr: string) => {
        let tmpItem = find(this.options, e => {
          return e.code === curr;
        });
        return [...prev, tmpItem];
      },
      [],
    );
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
